import type {SignalDataGapInterface} from '@interfaces/signal'

// The recent/24h gap count now comes from CORE (`data_gap_count_24h`) rather than
// being computed client-side over an inline list, and the full history is fetched
// page-by-page — so only the per-gap duration helpers remain here.
export const gapDurationSeconds = (gap: SignalDataGapInterface, nowMs: number): number =>
  ((gap.t_end ? new Date(gap.t_end).getTime() : nowMs) - new Date(gap.t_start).getTime()) / 1000

export const formatGapDuration = (seconds: number): string => {
  if (seconds < 60) return `${Math.round(seconds)} s`
  if (seconds < 3600) return `${(seconds / 60).toFixed(1)} min`
  if (seconds < 86400) return `${(seconds / 3600).toFixed(1)} h`
  return `${(seconds / 86400).toFixed(1)} d`
}
